import {
  PaymentsScheduleResponse,
  PaymentsScheduleResponseConverted,
} from '@/services/finance/typings';

export const handleConvertPaymentsSchedule = (
  data: PaymentsScheduleResponse[]
) => {
  return Array.from(new Set(data.map((item) => item.year))).map((year) => {
    return {
      year,
      payments: Array.from(data.filter((item) => item.year === year)).map(
        (item) => {
          return { month: item.month, payment: item.payment };
        }
      ),
    };
  });
};

export const getPaymentsSum = (
  paymentsSchedule: PaymentsScheduleResponseConverted[]
) => {
  let sum = 0;

  paymentsSchedule.forEach(({ payments }) => {
    payments.forEach(({ payment }) => (sum += Number(payment)));
  });

  return sum.toFixed(2);
};
